"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceDataHeader = exports.serialize = exports.getDeviceData = void 0;
const common_1 = require("./common");
__exportStar(require("./common"), exports);
function getDeviceData() {
    return {
        resolution: {
            w: screen.width,
            h: screen.height,
        },
        screen: {
            w: document.documentElement.scrollWidth,
            h: document.documentElement.scrollHeight,
        },
        locale: navigator.language,
        ts: new Date().toISOString(),
    };
}
exports.getDeviceData = getDeviceData;
function serialize(data) {
    return window.btoa(JSON.stringify(data));
}
exports.serialize = serialize;
function getDeviceDataHeader() {
    return {
        [common_1.ClientDeviceDataHeaderName]: serialize(getDeviceData()),
    };
}
exports.getDeviceDataHeader = getDeviceDataHeader;
